// Appels à l'API Pro. Le jeton suffit depuis le retrait du PIN de session.
export function proHeaders() {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('pro_token') || ''}`,
  };
}

// Le rôle porté par le compte connecté, pour n'afficher que ce qui est permis.
// Le serveur reste seul juge : ceci ne fait qu'éviter des boutons trompeurs.
export function proRole() {
  return localStorage.getItem('pro_role') || 'conducteur';
}
export const estPatron = () => proRole() === 'patron';

export async function proFetch(path, opts = {}) {
  const res = await fetch(`/api/pro${path}`, {
    ...opts,
    headers: { ...proHeaders(), ...opts.headers },
  });
  if (res.status === 401 || res.status === 403) {
    // Session expirée — on repart de la page de connexion.
    window.location.href = '/pro/login';
    throw new Error('Session expirée');
  }
  return res;
}
